import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Portlet,
    PortletBody,
    PortletHeader,
    PortletHeaderToolbar
} from "../../../partials/content/Portlet";
import {
    Container,
    Row,
    Col,
    Card,
    Button,
    Badge,
    Accordion,
    Modal,
    Form
} from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { store } from 'react-notifications-component';

import { VendorsServices } from './Vendors.services';
import { commonServices } from '../../../commonServices/commonServices';
import FilterComponent from '../../../partials/layout/FilterComponent';
import UltimatePagination from '../../../partials/layout/PaginationComponent';
import * as constants from '../../../constants';


const getVendorValidationSchema = (isEditMode) => {

    const baseSchema = {
        name: Yup.string().required('Vendor Name is required'),
        category: Yup.number().required('Category is required').typeError('Category is required'),
        phone: Yup.string()
            .required('Phone Number is required')
            .matches(/^[0-9]{10}$/, 'Phone Number must be exactly 10 digits'),
        email: Yup.string()
            .required('Email Address is required')
            .email('Enter a valid email address'),
        city: Yup.number()
            .required('City is required')
            .typeError('City is required'),
        address: Yup.string()
            .required('Address is required')
            .min(5, 'Address too short'),
    };

    if (!isEditMode) {
        baseSchema.accountNumber = Yup.string().required('Account Number is required');
        baseSchema.ifscCode = Yup.string()
            .required('IFSC Code is required')
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC Code (e.g. HDFC0001234)');
    }
    return Yup.object().shape(baseSchema);
};

class Vendors extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ...props,
            vendors: [],
            totalCount: undefined,
            isFetching: false,
            page: 1,
            total: undefined,
            offset: 0,
            limit: 10,
            requestedFilters: ['category', 'city', 'vendorStatus', 'kycStatus', 'search'],

            // Filter state values
            category: undefined,
            vendorStatus: undefined,
            kycStatus: undefined,
            rating: undefined,
            searchQuery: undefined,
            cityIds: [],
            selectedCities: [],
            formattedCities: [],

            // Modal state
            showAddVendorModal: false,

            isEditMode: false,
            editVendorId: null,
            editVendorData: null,

            accountVerified: false,
            isVerifying: false,
            // Details sidebar state
            showDetailsSidebar: false,
            selectedVendor: null,
            selectedVendorId: null,
            loadingVendorDetails: false,

            // Settlement modal state
            showSettlementModal: false,
            settlementVendor: null,
            isSettlementSubmitting: false,
            isSettlementEditMode: false,
            // Deactivate modal state
            showDeactivateModal: false,
        };
    }

    /**
     * Component Did Mount method
     */
    componentDidMount = async () => {
        await this.getVendorDetails();
        await this.getCities();
    }

    /**
     * Method to get vendors data from API
     */
    getVendorDetails = async () => {
        this.setState({ isFetching: true });
        const {
            offset,
            limit,
            category,
            vendorStatus,
            kycStatus,
            rating,
            searchQuery,
            cityIds,
        } = this.state;

        const data = {
            offset,
            limit,
            category: category && category !== 'All Categories' ? category : undefined,
            status: vendorStatus && vendorStatus !== 'All' ? vendorStatus : undefined,
            kycStatus: kycStatus && kycStatus !== 'All' ? kycStatus : undefined,
            rating: rating && rating !== 'All Ratings' ? rating : undefined,
            searchQuery: searchQuery || undefined,
            cityIds: cityIds && cityIds.length ? cityIds : undefined,
        };

        try {
            const result = await VendorsServices.getVendors(data);
            if (result && result.status === 200) {
                const totalCount = result.headers['x-total-count'];
                const totalPageNo = Math.ceil(totalCount / limit);
                this.setState({
                    vendors: result.data.vendors,
                    total: totalPageNo === 0 ? 1 : totalPageNo,
                    totalCount,
                    isFetching: false,
                });
            }
        } catch (error) {
            console.error('Failed to fetch vendors:', error);
            this.setState({ isFetching: false });
            store.addNotification({
                title: 'Error!',
                message: 'Failed to fetch vendors. Please try again.',
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 5000, onScreen: true, showIcon: true, pauseOnHover: true },
            });
        }
    }

    /**
     * Method to handle page change for pagination
     * @param {Number} page
     */
    onPageChange = async (page) => {
        const { limit } = this.state;
        const offset = (limit * (page - 1));
        await this.setState({ page, offset });
        await this.getVendorDetails();
    }

    /**
     * Method to reset page to first
     */
    resetPage = async () => {
        await this.setState({
            page: 1,
            offset: 0,
        });
    }

    /**
     * Method to handle filter data from FilterComponent child
     * @param {Object} childData
     */
    handleFilterChildData = async (childData) => {
        if (childData) {
            this.setState({ ...childData });
            await this.resetPage();
            await this.getVendorDetails();
        }
    }


    handleAddVendorButtonClick = () => {
        this.setState(state => ({
            showAddVendorModal: !state.showAddVendorModal,
            isEditMode: false,
            editVendorId: null,
            editVendorData: null,
            accountVerified: false,
            isVerifying: false,
        }));
    }


    handleEditVendorButtonClick = () => {
        const vendor = this.state.selectedVendor;
        if (!vendor) return;

        const editData = {
            name: vendor.fullName || '',
            category: vendor.serviceRequestCategory ? vendor.serviceRequestCategory.id : '',
            phone: vendor.phoneNumbers && vendor.phoneNumbers.length ? vendor.phoneNumbers[0].number : '',
            email: vendor.email || '',
            city: vendor.city && vendor.city.length ? vendor.city[0].id : '',
            address: vendor.residence || '',
            bankAccountHolderName: vendor.bankAccounts && vendor.bankAccounts.length ? vendor.bankAccounts[0].accountHolderName : '',
            bankName: vendor.bankAccounts && vendor.bankAccounts.length ? vendor.bankAccounts[0].bankName : '',
            accountNumber: vendor.bankAccounts && vendor.bankAccounts.length ? vendor.bankAccounts[0].accountNumber : '',
            ifscCode: vendor.bankAccounts && vendor.bankAccounts.length ? vendor.bankAccounts[0].ifsc : '',
            branch: vendor.bankAccounts && vendor.bankAccounts.length ? vendor.bankAccounts[0].branch : '',
        };

        this.setState({
            isEditMode: true,
            editVendorId: vendor.id,
            editVendorData: editData,
            showAddVendorModal: true,
            accountVerified: false,
            isVerifying: false,
        });
    }


    handleVerifyBankAccount = async (accountNumber, ifsc, setFieldValue) => {
        this.setState({ isVerifying: true });
        const data = { accountNumber, ifsc };
        const result = await commonServices.verifyBankAccount(data);
        if (result && result.status === 201) {
            const verificationData = result.data && result.data.bankAccountVerificationRequest;

            if (verificationData.bankName === 'NOT_AVAILABLE' || verificationData.branch === 'NOT_AVAILABLE') {
                store.addNotification({
                    title: 'Invalid IFSC Code',
                    message: 'The IFSC code you entered is invalid. Please check and try again.',
                    type: 'danger',
                    insert: 'top',
                    container: 'top-right',
                    animationIn: ['animated', 'fadeIn'],
                    animationOut: ['animated', 'fadeOut'],
                    dismiss: { duration: 5000, onScreen: true, showIcon: true, pauseOnHover: true },
                });
                this.setState({ isVerifying: false });
                return;
            }

            this.setState({ accountVerified: true });

            // Set the details received from Cashfree in the form.
            setFieldValue('bankAccountVerificationRequestId', verificationData.bankAccountVerificationRequestId);
            setFieldValue('bankAccountHolderName', verificationData.accountHolderName);
            setFieldValue('bankName', verificationData.bankName);
            setFieldValue('branch', verificationData.branch);
        } else {
            const errorMessage =
                (result && result.data && result.data.message) ||
                'Bank account verification failed. Please check account number and IFSC code.';
            store.addNotification({
                title: 'Verification Failed',
                message: typeof errorMessage === 'string' ? errorMessage : 'Bank account verification failed. Please check account number and IFSC code.',
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 5000, onScreen: true, showIcon: true, pauseOnHover: true },
            });
        }
        this.setState({ isVerifying: false });
    }


    handleVendorRowClick = async (vendor) => {
        this.setState({ loadingVendorDetails: true, selectedVendor: null, selectedVendorId: null });
        try {
            const result = await VendorsServices.getVendorById(vendor.id);

            if (result && result.status === 200) {
                this.setState({
                    selectedVendor: result.data,
                    selectedVendorId: vendor.id,
                    showDetailsSidebar: true,
                });
            }
        } catch (error) {
            console.error('Failed to fetch vendor details:', error);
            store.addNotification({
                title: 'Error!',
                message: 'Failed to load vendor details.',
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 5000, onScreen: true, showIcon: true, pauseOnHover: true },
            });
        }
        this.setState({ loadingVendorDetails: false });
    }


    handleCloseSidebar = () => {
        this.setState({ showDetailsSidebar: false, selectedVendor: null, selectedVendorId: null });
    }


    toggleDeactivateModal = () => {
        this.setState(state => ({ showDeactivateModal: !state.showDeactivateModal }));
    }

    handleToggleVendorStatus = async () => {
        const { selectedVendor, selectedVendorId } = this.state;
        if (!selectedVendor || !selectedVendorId) return;

        const isCurrentlyActive = selectedVendor.isActive;
        const newStatus = isCurrentlyActive ? 0 : 1;
        try {
            const result = await VendorsServices.updateVendor(
                selectedVendorId,
                { vendor: { isActive: newStatus } }
            );

            if (result && result.status === 200) {
                store.addNotification({
                    title: 'Success!',
                    message: isCurrentlyActive ? 'Vendor deactivated successfully.' : 'Vendor activated successfully.',
                    type: 'success',
                    insert: 'top',
                    container: 'top-right',
                    animationIn: ['animated', 'fadeIn'],
                    animationOut: ['animated', 'fadeOut'],
                    dismiss: { duration: 5000, onScreen: true, showIcon: true, pauseOnHover: true },
                });
                this.toggleDeactivateModal();
                this.handleCloseSidebar();
                await this.getVendorDetails();
            }
        } catch (error) {
            console.error('Failed to toggle vendor status:', error);
            store.addNotification({
                title: 'Error!',
                message: isCurrentlyActive ? 'Failed to deactivate vendor. Please try again.' : 'Failed to activate vendor. Please try again.',
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 5000, onScreen: true, showIcon: true, pauseOnHover: true },
            });
        }
    }

    toggleSettlementModal = (vendor = null, editMode = false) => {
        this.setState(state => ({
            showSettlementModal: !state.showSettlementModal,
            settlementVendor: vendor || state.settlementVendor,
            isSettlementEditMode: editMode,
        }));
    }

    /*
        create settlement account and create kyc documents
     */
    handleSettlementSubmit = async (aadhaarFile, panFile, cancelChequeFile) => {
        const { settlementVendor } = this.state;
        if (!settlementVendor) return;

        this.setState({ isSettlementSubmitting: true });

        const userId = settlementVendor.id;
        const bankAccountId = settlementVendor.bankAccounts && settlementVendor.bankAccounts.length ? settlementVendor.bankAccounts[0].id : null;

        const documents = [
            { name: 'Aadhaar Card', code: 'AADHAAR_CARD', file: aadhaarFile },
            { name: 'Pan Card', code: 'PAN_CARD', file: panFile },
            { name: 'Cancel Cheque', code: 'CANCEL_CHEQUE', file: cancelChequeFile },
        ];

        try {
            // Step 1: Upload kyc docs
            for (const doc of documents) {
                if (doc.file) {
                    const formData = new FormData();
                    formData.append('file', doc.file);
                    formData.append('documents[userId]', userId);
                    formData.append('documents[name]', doc.name);
                    formData.append('documents[code]', doc.code);

                    const docResult = await VendorsServices.createVendorDocuments(formData);
                    if (!docResult || docResult.status !== 201) {
                        throw new Error(`Failed to upload ${doc.name}`);
                    }
                }
            }

            // Step 2:create settlement account on cashfree
            if (!this.state.isSettlementEditMode && bankAccountId) {
                const settlementResult = await VendorsServices.createSettlementAccount(bankAccountId);
                if (!settlementResult || settlementResult.status !== 200) {
                    throw new Error('Settlement account creation failed on Cashfree');
                }
            }

            // Step 3:update isKYCVerified in Users table  
            await VendorsServices.updateVendor(userId, { vendor: { isKYCVerified: true } });

            store.addNotification({
                title: 'Success!',
                message: this.state.isSettlementEditMode
                    ? 'KYC documents updated successfully!'
                    : 'Documents uploaded and Settlement Account created successfully!',
                type: 'success',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 5000, onScreen: true, showIcon: true, pauseOnHover: true },
            });

            this.setState({ showSettlementModal: false });
            if (this.state.selectedVendorId) {
                await this.handleVendorRowClick({ id: this.state.selectedVendorId });
            }
            await this.getVendorDetails();

        } catch (error) {
            console.error('Settlement process failed:', error);
            store.addNotification({
                title: 'Error!',
                message: error.message || 'Settlement process failed. Please try again.',
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 5000, onScreen: true, showIcon: true, pauseOnHover: true },
            });
        }

        this.setState({ isSettlementSubmitting: false });
    }


    getBadge = (text, variant) => {
        return <Badge pill variant={variant}>{text}</Badge>;
    }

    getRowStyle = (vendorId) => {
        const isHover = this.state.hoveredVendorId === vendorId;
        return {
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            backgroundColor: isHover ? '#f9fafb' : '#fff',
            transform: isHover ? 'translateY(-2px)' : 'none',
            boxShadow: isHover ? '0 4px 12px rgba(0,0,0,0.08)' : 'none',
            borderRadius: '6px'
        };
    };


    /*
     get all the cities
      */
    getCities = async () => {
        const { cityIds } = this.state;
        const data = {
            pmsOperationStatus: 'YES'
        }
        const result = await commonServices.getCities(data);
        if (result && result.status === 200) {
            const cities = result?.data?.cities;
            const formattedCities = commonServices.formatCities(cities);
            let preSelectedCities = null;
            if (this.state.cityIds?.length > 0) {
                preSelectedCities = commonServices.preSelectCities(formattedCities, cityIds);
            }
            this.setState({ formattedCities });
            preSelectedCities && this.setState({ preSelectedCities });
        }
    }

    render() {
        const {
            vendors,
            totalCount,
            page,
            total,
            requestedFilters,
            category,
            vendorStatus,
            kycStatus,
            rating,
            searchQuery,
        } = this.state;

        let showPagination = false;
        if (total) { showPagination = total !== 0 && total !== 1; }

        if (this.state.isFetching) {
            return <p>{constants.LOADING_DATA}</p>;
        }

        return (
            <>
                <Container fluid>
                    <Portlet fluidHeight={true}>
                        <PortletHeader
                            title={`Vendors (${totalCount || 0})`}
                            toolbar={
                                <PortletHeaderToolbar>
                                    <Button variant="link" size="sm" onClick={this.handleAddVendorButtonClick}>
                                        Add Vendor
                                    </Button>
                                </PortletHeaderToolbar>
                            }
                        />
                        <PortletBody>

                            {/* -------- Filter Component  Section  ---------- */}
                            <FilterComponent
                                requestedFilters={requestedFilters}
                                serviceRequestCategories={this.props.vendorCategories}
                                selectedCategory={category}
                                searchQuery={searchQuery}
                                vendorStatus={vendorStatus}
                                kycStatus={kycStatus}
                                formattedCities={this.state.formattedCities}
                                preSelectedCities={this.state.selectedCities}
                                // rating={rating}
                                recordsPerPage={constants.RECORDS_PER_PAGE}
                                selectedRecordValue={this.state.limit}
                                filterParentCallback={this.handleFilterChildData}
                            />

                            {/* -------- Vendor tabular details ---------- */}
                            <Accordion defaultActiveKey="0" className="mt-2">
                                {vendors && vendors.length === 0 && <p>{constants.ZERO_DATA}</p>}
                                {vendors && vendors.length > 0 &&
                                    <Card key={'vendor-header'}>
                                        <Card.Header>
                                            <Row className="py-2 azuro-table-header">
                                                <Col md={2}><strong>Vendor Name</strong></Col>
                                                <Col md={2}><strong>Category</strong></Col>
                                                <Col md={2}><strong>Phone Number</strong></Col>
                                                <Col md={2}><strong>Email</strong></Col>
                                                <Col md={1}><strong>City</strong></Col>
                                                <Col md={1}><strong>Status</strong></Col>
                                                <Col md={1}><strong>KYC</strong></Col>
                                            </Row>
                                        </Card.Header>
                                    </Card>
                                }
                                {vendors && vendors.map(vendor => (
                                    <Card key={vendor.id}>
                                        <Card.Body
                                            className="py-2 azuro-table-row"
                                            onClick={() => this.handleVendorRowClick(vendor)}

                                            onMouseEnter={() => this.setState({ hoveredVendorId: vendor.id })}
                                            onMouseLeave={() => this.setState({ hoveredVendorId: null })}
                                            style={{
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease-in-out',
                                                backgroundColor: this.state.hoveredVendorId === vendor.id ? '#fff7ed' : '#fff',
                                                transform: this.state.hoveredVendorId === vendor.id ? 'translateY(-2px)' : 'none',
                                                boxShadow: this.state.hoveredVendorId === vendor.id
                                                    ? '0 4px 12px rgba(249, 115, 22, 0.2)'
                                                    : 'none',
                                                borderRadius: '6px',
                                                borderLeft: this.state.hoveredVendorId === vendor.id
                                                    ? '4px solid #f97316'
                                                    : '4px solid transparent'
                                            }}
                                        >
                                            <Row>
                                                <Col md={2}>{vendor.name}</Col>
                                                <Col md={2}>{vendor.category || <span className="small text-muted">N/A</span>}</Col>
                                                <Col md={2}>{vendor.phone}</Col>
                                                <Col md={2}>{vendor.email}</Col>
                                                <Col md={1}>{vendor.city || <span className="small text-muted">N/A</span>}</Col>

                                                <Col md={1}>
                                                    {vendor.status === 'Active'
                                                        ? this.getBadge('Active', 'success')
                                                        : this.getBadge('Inactive', 'secondary')}
                                                </Col>
                                                <Col md={1}>
                                                    {vendor.kycStatus === 'Verified'
                                                        ? this.getBadge('Verified', 'success')
                                                        : this.getBadge('Pending', 'warning')}
                                                </Col>

                                            </Row>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </Accordion>

                            {/* Pagination */}
                            {showPagination && <UltimatePagination
                                currentPage={page}
                                totalPages={total}
                                onChange={this.onPageChange}
                                boundaryPagesRange={0}
                                hidePreviousAndNextPageLinks={true}
                                hideFirstAndLastPageLinks={page !== 1 && page !== total ? false : true}
                            />}
                        </PortletBody>
                    </Portlet>
                </Container>


                <Modal backdrop="static" keyboard={false} show={this.state.showAddVendorModal} onHide={this.handleAddVendorButtonClick}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.state.isEditMode ? 'Edit Vendor' : 'Add New Vendor'}
                            <br />
                            <small className="text-muted" style={{ fontSize: '0.75rem', fontWeight: 'normal' }}>
                                {this.state.isEditMode ? 'Update vendor information' : 'Register a new service provider'}
                            </small>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Formik

                            enableReinitialize={true}
                            initialValues={this.state.isEditMode && this.state.editVendorData
                                ? {
                                    // Edit Mode selectedVendor  pre-filled values
                                    name: this.state.editVendorData.name,
                                    category: this.state.editVendorData.category,
                                    phone: this.state.editVendorData.phone,
                                    email: this.state.editVendorData.email,
                                    city: this.state.editVendorData.city || null,
                                    address: this.state.editVendorData.address,
                                    bankAccountHolderName: this.state.editVendorData.bankAccountHolderName,
                                    bankName: this.state.editVendorData.bankName,
                                    accountNumber: this.state.editVendorData.accountNumber,
                                    ifscCode: this.state.editVendorData.ifscCode,
                                    branch: this.state.editVendorData.branch,
                                    bankAccountVerificationRequestId: '',
                                }
                                : {
                                    // Add Mode
                                    name: '',
                                    category: '',
                                    phone: '',
                                    email: '',
                                    city: '',
                                    address: '',
                                    bankAccountHolderName: '',
                                    bankName: '',
                                    accountNumber: '',
                                    ifscCode: '',
                                    branch: '',
                                    bankAccountVerificationRequestId: '',
                                }
                            }
                            validationSchema={getVendorValidationSchema(this.state.isEditMode)}
                            onSubmit={async (values, { setSubmitting, resetForm }) => {

                                if (this.state.isEditMode) {

                                    const updatePayload = {
                                        vendor: {
                                            name: values.name,
                                            category: values.category,
                                            phone: values.phone,
                                            email: values.email,
                                            address: values.address || '',
                                            ...(values.city ? { cityId: values.city } : {}),
                                        },
                                    };

                                    const result = await VendorsServices.updateVendor(
                                        this.state.editVendorId,
                                        updatePayload
                                    );

                                    if (result && (result.status === 200 || result.status === 201)) {
                                        store.addNotification({
                                            title: 'Success!',
                                            message: 'Vendor updated successfully!',
                                            type: 'success',
                                            insert: 'top',
                                            container: 'top-right',
                                            animationIn: ['animated', 'fadeIn'],
                                            animationOut: ['animated', 'fadeOut'],
                                            dismiss: { duration: 5000, onScreen: true, showIcon: true, pauseOnHover: true },
                                        });
                                        resetForm();
                                        this.handleAddVendorButtonClick();
                                        this.handleCloseSidebar();
                                        await this.getVendorDetails();
                                    }
                                } else {

                                    const formData = new FormData();
                                    formData.append('vendor[name]', values.name);
                                    formData.append('vendor[category]', values.category);
                                    formData.append('vendor[phone]', values.phone);
                                    formData.append('vendor[email]', values.email);
                                    values.city && formData.append('vendor[cityId]', values.city);
                                    values.address && formData.append('vendor[address]', values.address);
                                    formData.append('vendor[bankAccountHolderName]', values.bankAccountHolderName);
                                    formData.append('vendor[bankName]', values.bankName);
                                    formData.append('vendor[accountNumber]', values.accountNumber);
                                    formData.append('vendor[ifscCode]', values.ifscCode);
                                    values.branch && formData.append('vendor[branch]', values.branch);
                                    formData.append('vendor[bankAccountVerificationRequestId]', values.bankAccountVerificationRequestId);
                                    formData.append('vendor[serviceRequestCategoryId]', values.category);

                                    const result = await VendorsServices.createVendor(formData);

                                    if (result && (result.status === 200 || result.status === 201)) {
                                        store.addNotification({
                                            title: 'Success!',
                                            message: 'New vendor added successfully!',
                                            type: 'success',
                                            insert: 'top',
                                            container: 'top-right',
                                            animationIn: ['animated', 'fadeIn'],
                                            animationOut: ['animated', 'fadeOut'],
                                            dismiss: { duration: 5000, onScreen: true, showIcon: true, pauseOnHover: true },
                                        });
                                        resetForm();
                                        this.handleAddVendorButtonClick();
                                        await this.getVendorDetails();
                                    }
                                }
                                setSubmitting(false);
                            }}
                        >
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        {/* Vendor Name */}
                                        <Col xs={12} md={6}>
                                            <Form.Group controlId="vendorName">
                                                <Form.Label>Vendor Name <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter name or business name"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.name}
                                                />
                                                {errors.name && touched.name && (
                                                    <Form.Text className="text-danger">{errors.name}</Form.Text>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* Category */}
                                        <Col xs={12} md={6}>
                                            <Form.Group controlId="vendorCategory">
                                                <Form.Label>Category <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="category"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.category}
                                                >
                                                    <option value="">{constants.DEFAULT_OPTION}</option>
                                                    {this.props.serviceRequestCategories && this.props.serviceRequestCategories.map((cat) => (
                                                        <option key={'cat' + cat.id} value={cat.id}>{cat.name}</option>
                                                    ))}
                                                </Form.Control>
                                                {errors.category && touched.category && (
                                                    <Form.Text className="text-danger">{errors.category}</Form.Text>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* Phone Number */}
                                        <Col xs={12} md={6}>
                                            <Form.Group controlId="vendorPhone">
                                                <Form.Label>Phone Number <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="phone"
                                                    placeholder="+91 98765 43210"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.phone}
                                                    disabled={this.state.isEditMode}
                                                />
                                                {errors.phone && touched.phone && (
                                                    <Form.Text className="text-danger">{errors.phone}</Form.Text>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* Email Address */}
                                        <Col xs={12} md={6}>
                                            <Form.Group controlId="vendorEmail">
                                                <Form.Label>Email Address <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    placeholder="vendor@email.com"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.email}
                                                    disabled={this.state.isEditMode}
                                                />
                                                {errors.email && touched.email && (
                                                    <Form.Text className="text-danger">{errors.email}</Form.Text>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* City */}
                                        <Col xs={12} md={6}>
                                            <Form.Group controlId="vendorCity">
                                                <Form.Label>City <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="city"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.city}
                                                >
                                                    <option value="">{constants.DEFAULT_OPTION}</option>
                                                    {this.state.formattedCities && this.state.formattedCities.map((city) => (
                                                        <option key={`city-${city.id}`} value={city.id}>{city.label}</option>
                                                    ))}
                                                </Form.Control>
                                                {errors.city && touched.city && (
                                                    <Form.Text className="text-danger">{errors.city}</Form.Text>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* Address */}
                                        <Col xs={12}>
                                            <Form.Group controlId="vendorAddress">
                                                <Form.Label>Address <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={2}
                                                    name="address"
                                                    placeholder="Enter full address"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.address}
                                                />
                                                {errors.address && touched.address && (
                                                    <Form.Text className="text-danger">{errors.address}</Form.Text>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* ===== BANK ACCOUNT SECTION ===== */}
                                        <Col xs={12}>
                                            <hr />
                                            <p className="font-weight-bold mb-3"><i className="flaticon2-rectangle mr-2"></i>Bank Account Details (for Payouts)</p>
                                        </Col>

                                        {this.state.isEditMode ? (
                                            <>
                                                {/* Edit Mode: Read-only bank details */}
                                                <Col xs={12} md={6}>
                                                    <Form.Group controlId="bankAccountHolderNameEdit">
                                                        <Form.Label>Account Holder Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={values.bankAccountHolderName || 'N/A'}
                                                            disabled
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={12} md={6}>
                                                    <Form.Group controlId="bankNameEdit">
                                                        <Form.Label>Bank Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={values.bankName || 'N/A'}
                                                            disabled
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={12} md={4}>
                                                    <Form.Group controlId="accountNumberEdit">
                                                        <Form.Label>Account Number</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={values.accountNumber ? `****${values.accountNumber.slice(-4)}` : 'N/A'}
                                                            disabled
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={12} md={4}>
                                                    <Form.Group controlId="ifscCodeEdit">
                                                        <Form.Label>IFSC Code</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={values.ifscCode || 'N/A'}
                                                            disabled
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={12} md={4}>
                                                    <Form.Group controlId="branchEdit">
                                                        <Form.Label>Branch</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={values.branch || 'N/A'}
                                                            disabled
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                        ) : (
                                            <>
                                                {/* Add Mode Section */}
                                                {!this.state.accountVerified && <>
                                                    <Col xs={12} md={6}>
                                                        <Form.Group controlId="accountNumber">
                                                            <Form.Label>Account Number <span className="text-danger">*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="accountNumber"
                                                                placeholder="Enter account number"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.accountNumber}
                                                            />
                                                            {errors.accountNumber && touched.accountNumber && (
                                                                <Form.Text className="text-danger">{errors.accountNumber}</Form.Text>
                                                            )}
                                                        </Form.Group>
                                                    </Col>

                                                    <Col xs={12} md={6}>
                                                        <Form.Group controlId="ifscCode">
                                                            <Form.Label>IFSC Code <span className="text-danger">*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="ifscCode"
                                                                placeholder="e.g., HDFC0001234"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.ifscCode}
                                                            />
                                                            {errors.ifscCode && touched.ifscCode && (
                                                                <Form.Text className="text-danger">{errors.ifscCode}</Form.Text>
                                                            )}
                                                        </Form.Group>
                                                    </Col>

                                                    {/* Cashfree Info Note */}
                                                    <Col xs={12}>
                                                        <div className="p-3 rounded" style={{ backgroundColor: '#f0f7ff', border: '1px solid #cce0ff' }}>
                                                            <p className="mb-1 font-weight-bold"><i className="flaticon2-shield mr-2"></i>Cashfree Verification</p>
                                                            <p className="mb-0 small text-muted">Click "Verify Bank Account" to verify bank details via Cashfree. After verification, account holder name and bank name will auto-fill.</p>
                                                        </div>
                                                    </Col>

                                                    {/* Verify Bank Account Button */}
                                                    <Col xs={12} className="text-right mt-3">
                                                        <Button variant="secondary" className="mr-2" onClick={this.handleAddVendorButtonClick}>
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            type="button"
                                                            variant="primary"
                                                            disabled={this.state.isVerifying || !values.accountNumber || !values.ifscCode}
                                                            onClick={() => {
                                                                this.handleVerifyBankAccount(values.accountNumber, values.ifscCode, setFieldValue);
                                                            }}
                                                        >
                                                            {this.state.isVerifying ? 'Verifying...' : 'Verify Bank Account'}
                                                        </Button>
                                                    </Col>
                                                </>}

                                                {this.state.accountVerified && <>
                                                    <Col xs={12}>
                                                        <p className="text-warning"><i className="flaticon-warning mr-2"></i>Verify the bank details below before adding the vendor!</p>
                                                    </Col>

                                                    <Col xs={12} md={6}>
                                                        <Form.Group controlId="bankAccountHolderNameVerified">
                                                            <Form.Label>Account Holder Name</Form.Label>
                                                            <Form.Control
                                                                className="border-success"
                                                                type="text"
                                                                name="bankAccountHolderName"
                                                                readOnly
                                                                value={values.bankAccountHolderName}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col xs={12} md={6}>
                                                        <Form.Group controlId="bankNameVerified">
                                                            <Form.Label>Bank Name</Form.Label>
                                                            <Form.Control
                                                                className="border-success"
                                                                type="text"
                                                                name="bankName"
                                                                readOnly
                                                                value={values.bankName}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col xs={12} md={4}>
                                                        <Form.Group controlId="accountNumberVerified">
                                                            <Form.Label>Account Number</Form.Label>
                                                            <Form.Control
                                                                className="border-success"
                                                                type="text"
                                                                name="accountNumber"
                                                                readOnly
                                                                value={values.accountNumber}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col xs={12} md={4}>
                                                        <Form.Group controlId="ifscCodeVerified">
                                                            <Form.Label>IFSC Code</Form.Label>
                                                            <Form.Control
                                                                className="border-success"
                                                                type="text"
                                                                name="ifscCode"
                                                                readOnly
                                                                value={values.ifscCode}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col xs={12} md={4}>
                                                        <Form.Group controlId="branchVerified">
                                                            <Form.Label>Branch</Form.Label>
                                                            <Form.Control
                                                                className="border-success"
                                                                type="text"
                                                                name="branch"
                                                                readOnly
                                                                value={values.branch}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    {/* Action Buttons */}
                                                    <Col xs={12} className="text-right mt-2">
                                                        <Button
                                                            variant="secondary"
                                                            className="mr-2"
                                                            onClick={() => this.setState({ accountVerified: false })}
                                                        >
                                                            Change Bank Details
                                                        </Button>
                                                        <Button variant="outline-secondary" className="mr-2" onClick={this.handleAddVendorButtonClick}>
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            variant="primary"
                                                            type="submit"
                                                            disabled={isSubmitting}
                                                        >
                                                            {isSubmitting ? 'Saving...' : '+ Add Vendor'}
                                                        </Button>
                                                    </Col>
                                                </>}
                                            </>
                                        )}


                                        {this.state.isEditMode && <>
                                            <Col xs={12} className="text-right mt-3">
                                                <Button variant="secondary" className="mr-2" onClick={this.handleAddVendorButtonClick}>
                                                    Cancel
                                                </Button>
                                                <Button
                                                    variant="primary"
                                                    type="submit"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? 'Saving...' : 'Save Changes'}
                                                </Button>
                                            </Col>
                                        </>}
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    </Modal.Body>
                </Modal>

                {/* Vendor Details Sidebar */}
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        width: '800px',
                        height: '100vh',
                        backgroundColor: '#fff',
                        boxShadow: this.state.showDetailsSidebar ? '0 0 20px rgba(0, 0, 0, 0.15)' : 'none',
                        zIndex: 1050,
                        transform: this.state.showDetailsSidebar ? 'translateX(0)' : 'translateX(100%)',
                        transition: 'transform 0.3s ease-in-out',
                        overflowY: 'auto',
                    }}
                >
                    {this.state.loadingVendorDetails ? (
                        <div className="p-4 text-center">
                            <p>{constants.LOADING_DATA}</p>
                        </div>
                    ) : this.state.selectedVendor ? (
                        <div>

                            {/* Header */}
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '1rem',
                                    borderBottom: '1px solid #e9ecef',
                                    position: 'sticky',
                                    top: 0,
                                    backgroundColor: '#fff',
                                    zIndex: 1051,
                                }}
                            >
                                <h5 style={{ marginBottom: 0 }}>Vendor Details</h5>
                                <Button
                                    variant="link"
                                    size="lg"
                                    className="p-0"
                                    onClick={this.handleCloseSidebar}
                                    style={{ textDecoration: 'none', color: '#6c757d' }}
                                >
                                    ×
                                </Button>
                            </div>

                            <div className="p-4">

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                                    <div
                                        style={{
                                            width: '56px',
                                            height: '56px',
                                            borderRadius: '50%',
                                            backgroundColor: '#1976d2',
                                            color: '#fff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '22px',
                                            fontWeight: '600',
                                        }}
                                    >
                                        {
                                            this.state.selectedVendor.fullName
                                                ? this.state.selectedVendor.fullName
                                                    .trim()
                                                    .split(/\s+/)
                                                    .filter(word => word.length)
                                                    .map(word => word[0].toUpperCase())
                                                    .slice(0, 2)
                                                    .join('')
                                                : 'V'
                                        }
                                    </div>

                                    <div style={{ marginLeft: '1rem' }}>
                                        <h6 style={{ marginBottom: '2px', fontWeight: '600' }}>
                                            {this.state.selectedVendor.fullName}
                                        </h6>
                                        <small style={{ color: '#6c757d' }}>
                                            {this.state.selectedVendor.serviceRequestCategory ? this.state.selectedVendor.serviceRequestCategory.name : 'N/A'}
                                        </small>
                                    </div>
                                </div>

                                {/* Status */}

                                <div style={{
                                    marginBottom: '1.5rem',
                                    display: 'flex',
                                    gap: '10px',
                                    flexWrap: 'wrap'
                                }}>

                                    <Badge
                                        pill
                                        style={{
                                            background: this.state.selectedVendor.isActive ? '#ecfdf5' : '#fef2f2',
                                            color: this.state.selectedVendor.isActive ? '#065f46' : '#991b1b',
                                            padding: '6px 14px',
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            letterSpacing: '0.3px',
                                            border: this.state.selectedVendor.isActive
                                                ? '1px solid #a7f3d0'
                                                : '1px solid #fecaca'
                                        }}
                                    >
                                        {this.state.selectedVendor.isActive ? '● Active' : '● Inactive'}
                                    </Badge>

                                    <Badge
                                        pill
                                        style={{
                                            background: this.state.selectedVendor.isKYCVerified ? '#ecfdf5' : '#fef2f2',
                                            color: this.state.selectedVendor.isKYCVerified ? '#065f46' : '#991b1b',
                                            padding: '6px 14px',
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            letterSpacing: '0.3px',
                                            border: this.state.selectedVendor.isKYCVerified
                                                ? '1px solid #a7f3d0'
                                                : '1px solid #fecaca'
                                        }}
                                    >
                                        {this.state.selectedVendor.isKYCVerified
                                            ? '✓ KYC Verified'
                                            : '✗ KYC Not Verified'}
                                    </Badge>

                                    {this.state.selectedVendor?.bankAccounts?.[0]?.cashfreeBeneficiaryId && (
                                        <Badge pill style={{
                                            background: '#ecfdf5',
                                            color: '#065f46',
                                            padding: '6px 14px',
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            letterSpacing: '0.3px',
                                            border: '1px solid #a7f3d0'
                                        }}>
                                            ✔ Payouts Enabled
                                        </Badge>
                                    )}
                                </div>


                                {/* Metrics */}
                                <Row style={{ marginBottom: '1.5rem' }}>
                                    <Col md={4}>
                                        <div style={{
                                            background: '#f1f3f5',
                                            borderRadius: '10px',
                                            padding: '12px',
                                            textAlign: 'center',
                                        }}>
                                            <div style={{ fontWeight: '700', fontSize: '20px', color: '#FFC107' }}>
                                                {this.state.selectedVendor.rating
                                                    ? this.state.selectedVendor.rating.toFixed(1)
                                                    : 'N/A'}
                                            </div>
                                            <small style={{ color: '#6c757d' }}>Rating</small>
                                        </div>
                                    </Col>

                                    <Col md={4}>
                                        <div style={{
                                            background: '#f1f3f5',
                                            borderRadius: '10px',
                                            padding: '12px',
                                            textAlign: 'center',
                                        }}>
                                            <div style={{ fontWeight: '700', fontSize: '20px', color: '#1976d2' }}>
                                                {this.state.selectedVendor.jobsDone || 0}
                                            </div>
                                            <small style={{ color: '#6c757d' }}>Jobs Done</small>
                                        </div>
                                    </Col>

                                    <Col md={4}>
                                        <div style={{
                                            background: '#e8f5e9',
                                            borderRadius: '10px',
                                            padding: '12px',
                                            textAlign: 'center',
                                        }}>
                                            <div style={{ fontWeight: '700', fontSize: '20px', color: '#2e7d32' }}>
                                                ₹{this.state.selectedVendor.totalEarned || 0}
                                            </div>
                                            <small style={{ color: '#6c757d' }}>Total Earned</small>
                                        </div>
                                    </Col>
                                </Row>


                                {/* Contact Info */}
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <h6 style={{ marginBottom: '1rem', fontWeight: '600' }}>
                                        Contact Information
                                    </h6>

                                    <div style={{
                                        background: '#f1f3f5',
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        marginBottom: '8px',
                                    }}>
                                        📞 {this.state.selectedVendor.phoneNumbers && this.state.selectedVendor.phoneNumbers.length
                                            ? `${this.state.selectedVendor.phoneNumbers[0].countryCode || ''} ${this.state.selectedVendor.phoneNumbers[0].number}`
                                            : 'N/A'}
                                    </div>

                                    <div style={{
                                        background: '#f1f3f5',
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        marginBottom: '8px',
                                    }}>
                                        ✉️ {this.state.selectedVendor.email || 'N/A'}
                                    </div>

                                    <div style={{
                                        background: '#f1f3f5',
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                    }}>
                                        🏠 {this.state.selectedVendor.residence + ", " + (this.state.selectedVendor.city && this.state.selectedVendor.city.length ? this.state.selectedVendor.city[0].name : 'N/A')}
                                    </div>
                                </div>

                                {/* KYC Documents Section */}
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <h6 style={{ marginBottom: '1rem', fontWeight: '600' }}>KYC Documents</h6>
                                    <div style={{
                                        background: '#f8f9fa',
                                        padding: '12px',
                                        borderRadius: '10px',
                                    }}>
                                        {['AADHAAR_CARD', 'PAN_CARD', 'CANCEL_CHEQUE'].map(code => {
                                            const doc = this.state.selectedVendor.documents?.find(d => d.code === code);
                                            return (
                                                <Row key={code} className="mb-2 align-items-center">
                                                    <Col xs={6}>
                                                        <small className="text-muted">{code.replace('_', ' ')}</small>
                                                    </Col>
                                                    <Col xs={6} className="text-right">
                                                        {doc ? (
                                                            <a href={doc.file} target="_blank" rel="noopener noreferrer" className="btn btn-link btn-sm p-0">
                                                                View Document
                                                            </a>
                                                        ) : (
                                                            <small className="text-danger">Not Uploaded</small>
                                                        )}
                                                    </Col>
                                                </Row>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Bank Details */}
                                {this.state.selectedVendor.bankAccounts && this.state.selectedVendor.bankAccounts.length > 0 && (
                                    <div style={{ marginBottom: '1.5rem' }}>
                                        <h6 style={{ marginBottom: '1rem', fontWeight: '600' }}>Bank Account Details</h6>

                                        <div style={{
                                            background: '#f8f9fa',
                                            padding: '12px',
                                            borderRadius: '10px',
                                        }}>
                                            <Row>
                                                <Col xs={6}><small className="text-muted">Bank</small></Col>
                                                <Col xs={6} className="text-right">
                                                    {this.state.selectedVendor.bankAccounts[0].bankName}
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs={6}><small className="text-muted">Account</small></Col>
                                                <Col xs={6} className="text-right">
                                                    ****{this.state.selectedVendor.bankAccounts[0].accountNumber?.slice(-4)}
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs={6}><small className="text-muted">IFSC</small></Col>
                                                <Col xs={6} className="text-right">
                                                    {this.state.selectedVendor.bankAccounts[0].ifsc}
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )}

                                {/* Activity */}
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <h6 style={{ marginBottom: '1rem', fontWeight: '600' }}>Activity</h6>

                                    <div style={{
                                        background: '#f8f9fa',
                                        padding: '12px',
                                        borderRadius: '10px',
                                    }}>
                                        <Row>
                                            <Col xs={6}><small className="text-muted">Joined On</small></Col>
                                            <Col xs={6} className="text-right">
                                                {new Date(this.state.selectedVendor.createdAt).toLocaleDateString('en-US', {
                                                    month: 'short',
                                                    day: 'numeric',
                                                    year: 'numeric'
                                                })}
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xs={6}><small className="text-muted">Last Job</small></Col>
                                            <Col xs={6} className="text-right">
                                                {new Date(this.state.selectedVendor.user_createdAt).toLocaleDateString('en-US', {
                                                    month: 'short',
                                                    day: 'numeric',
                                                    year: 'numeric'
                                                })}
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                {/* Actions Footer */}
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: '16px',
                                        marginTop: '2.5rem',
                                        paddingTop: '2rem',
                                        borderTop: '1px solid #eee',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                >

                                    {
                                        this.state.selectedVendor.isActive ? (
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                style={{ padding: '8px 20px', borderRadius: '6px', fontWeight: '500' }}
                                                onClick={this.handleEditVendorButtonClick}
                                            >
                                                <i className="flaticon-edit mr-2"></i> Edit Vendor
                                            </Button>


                                        ) : null
                                    }

                                    {this.state.selectedVendor.isActive ? (
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            style={{ padding: '8px 20px', borderRadius: '6px', fontWeight: '500' }}
                                            onClick={this.toggleDeactivateModal}
                                        >
                                            <i className="flaticon-circle mr-2"></i> Deactivate
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="outline-success"
                                            size="sm"
                                            style={{ padding: '8px 20px', borderRadius: '6px', fontWeight: '500' }}
                                            onClick={this.toggleDeactivateModal}
                                        >
                                            <i className="flaticon2-check-mark mr-2"></i> Activate
                                        </Button>
                                    )}
                                    {

                                        this.state.selectedVendor.isActive && (
                                            this.state.selectedVendor?.bankAccounts?.[0]?.cashfreeBeneficiaryId ? (
                                                <Button
                                                    size="sm"
                                                    style={{
                                                        padding: '8px 18px',
                                                        borderRadius: '6px',
                                                        fontWeight: '500',
                                                        fontSize: '13px',
                                                        backgroundColor: '#eff6ff',
                                                        color: '#1e40af',
                                                        border: '1px solid #bfdbfe',
                                                        boxShadow: '0 1px 2px rgba(59, 130, 246, 0.1)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                    }}
                                                    onClick={() =>
                                                        this.toggleSettlementModal(this.state.selectedVendor, true)
                                                    }
                                                    onMouseEnter={(e) => e.currentTarget.style.background = '#dbeafe'}
                                                    onMouseLeave={(e) => e.currentTarget.style.background = '#eff6ff'}
                                                >
                                                    <i className="flaticon-edit"></i>
                                                    Edit KYC Documents
                                                </Button>
                                            ) : (
                                                <Button
                                                    size="sm"
                                                    style={{
                                                        padding: '8px 18px',
                                                        borderRadius: '6px',
                                                        fontWeight: '500',
                                                        fontSize: '13px',
                                                        backgroundColor: '#ecfdf5',
                                                        color: '#065f46',
                                                        border: '1px solid #a7f3d0',
                                                        boxShadow: '0 1px 2px rgba(16, 185, 129, 0.1)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        cursor: this.state.selectedVendor?.bankAccount_cashfreeBeneficiaryId
                                                            ? 'not-allowed'
                                                            : 'pointer',
                                                    }}
                                                    onClick={() =>
                                                        !this.state.selectedVendor?.bankAccounts?.[0]?.cashfreeBeneficiaryId &&
                                                        this.toggleSettlementModal(this.state.selectedVendor)
                                                    }
                                                    disabled={this.state.selectedVendor?.bankAccounts?.[0]?.cashfreeBeneficiaryId}
                                                    onMouseEnter={(e) => e.currentTarget.style.background = '#d1fae5'}
                                                    onMouseLeave={(e) => e.currentTarget.style.background = '#ecfdf5'}
                                                >
                                                    <i className="flaticon2-shield"></i>
                                                    Create Settlement Account ?
                                                </Button>
                                            ))

                                    }

                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>

                {/* Overlay for sidebar */}
                {this.state.showDetailsSidebar && (
                    <div
                        onClick={this.handleCloseSidebar}
                        style={{
                            position: 'fixed',
                            top: 0,
                            right: '-500px',
                            width: '500px',
                            height: '100vh',
                            backgroundColor: '#fff',
                            zIndex: 9999,
                            transition: 'right 0.3s ease',

                        }}
                    />
                )}
                {/* Deactivate Confirmation Modal */}
                <Modal show={this.state.showDeactivateModal} onHide={this.toggleDeactivateModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.state.selectedVendor?.isActive ? 'Deactivate' : 'Activate'} Vendor
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to {this.state.selectedVendor?.isActive ? 'deactivate' : 'activate'}{' '}
                        <strong>{this.state.selectedVendor?.fullName}</strong>?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.toggleDeactivateModal}>
                            No
                        </Button>
                        <Button
                            variant={this.state.selectedVendor?.isActive ? 'danger' : 'success'}
                            onClick={this.handleToggleVendorStatus}
                        >
                            Yes, {this.state.selectedVendor?.isActive ? 'Deactivate' : 'Activate'}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* ===== CREATE SETTLEMENT ACCOUNT MODAL ===== */}
                <Modal
                    backdrop="static"
                    keyboard={false}
                    show={this.state.showSettlementModal}
                    onHide={() => this.toggleSettlementModal(null)}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.state.isSettlementEditMode ? 'Edit KYC Documents' : 'Create Settlement Account'}
                            <br />
                            <small className="text-muted" style={{ fontSize: '0.75rem', fontWeight: 'normal' }}>
                                {this.state.isSettlementEditMode
                                    ? 'Update KYC documents for this vendor'
                                    : 'Upload KYC documents and mark for Cashfree settlements'}
                            </small>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Formik
                            initialValues={{
                                aadhaarFile: null,
                                panFile: null,
                                cancelChequeFile: null,
                            }}
                            validate={values => {
                                const errors = {};
                                const existingDocs = this.state.settlementVendor?.documents || [];

                                const hasAadhaar = existingDocs.find(d => d.code === 'AADHAAR_CARD');
                                if (!values.aadhaarFile && (!this.state.isSettlementEditMode || !hasAadhaar)) {
                                    errors.aadhaarFile = 'Aadhaar Card is required';
                                }

                                const hasPan = existingDocs.find(d => d.code === 'PAN_CARD');
                                if (!values.panFile && (!this.state.isSettlementEditMode || !hasPan)) {
                                    errors.panFile = 'Pan Card is required';
                                }

                                const hasCheque = existingDocs.find(d => d.code === 'CANCEL_CHEQUE');
                                if (!values.cancelChequeFile && (!this.state.isSettlementEditMode || !hasCheque)) {
                                    errors.cancelChequeFile = 'Cancel Cheque is required';
                                }

                                return errors;
                            }}
                            onSubmit={async (values) => {
                                await this.handleSettlementSubmit(
                                    values.aadhaarFile,
                                    values.panFile,
                                    values.cancelChequeFile
                                );
                            }}
                        >
                            {({ values, errors, touched, handleSubmit, setFieldValue }) => (
                                <Form onSubmit={handleSubmit}>

                                    {/* Vendor Info Banner */}
                                    {this.state.settlementVendor && (
                                        <div style={{
                                            background: '#f8f9fa',
                                            padding: '12px 16px',
                                            borderRadius: '8px',
                                            marginBottom: '1.5rem',
                                            border: '1px solid #e9ecef'
                                        }}>
                                            <p className="mb-1 font-weight-bold">
                                                {this.state.settlementVendor.fullName}
                                            </p>
                                            <p className="mb-0 small text-muted">
                                                Bank: {this.state.settlementVendor.bankAccounts?.[0]?.bankName || 'N/A'} |
                                                A/C: ****{this.state.settlementVendor.bankAccounts?.[0]?.accountNumber?.slice(-4) || 'N/A'} |
                                                IFSC: {this.state.settlementVendor.bankAccounts?.[0]?.ifsc || 'N/A'}
                                            </p>
                                        </div>
                                    )}

                                    {/* File Upload Section */}
                                    <p className="font-weight-bold mb-3">
                                        <i className="flaticon-upload mr-2"></i>
                                        Upload KYC Documents
                                    </p>

                                    {/* 1. Aadhaar Card Upload */}
                                    <Form.Group controlId="aadhaarFile">
                                        <Form.Label>
                                            Aadhaar Card {(!this.state.isSettlementEditMode || !this.state.settlementVendor?.documents?.find(d => d.code === 'AADHAAR_CARD')) && <span className="text-danger">*</span>}
                                        </Form.Label>
                                        {this.state.isSettlementEditMode && this.state.settlementVendor?.documents?.find(d => d.code === 'AADHAAR_CARD') && (
                                            <div className="mb-2">
                                                <small className="text-success mr-2">Existing: </small>
                                                <a href={this.state.settlementVendor.documents.find(d => d.code === 'AADHAAR_CARD').file} target="_blank" rel="noopener noreferrer" className="small">View Current Aadhaar</a>
                                            </div>
                                        )}
                                        <Form.Control
                                            type="file"
                                            name="aadhaarFile"
                                            accept="image/*,.pdf"
                                            onChange={(e) => setFieldValue('aadhaarFile', e.currentTarget.files[0])}
                                        />
                                        {errors.aadhaarFile && touched.aadhaarFile && (
                                            <Form.Text className="text-danger">{errors.aadhaarFile}</Form.Text>
                                        )}
                                    </Form.Group>

                                    {/* 2. Pan Card Upload */}
                                    <Form.Group controlId="panFile">
                                        <Form.Label>
                                            Pan Card {(!this.state.isSettlementEditMode || !this.state.settlementVendor?.documents?.find(d => d.code === 'PAN_CARD')) && <span className="text-danger">*</span>}
                                        </Form.Label>
                                        {this.state.isSettlementEditMode && this.state.settlementVendor?.documents?.find(d => d.code === 'PAN_CARD') && (
                                            <div className="mb-2">
                                                <small className="text-success mr-2">Existing: </small>
                                                <a href={this.state.settlementVendor.documents.find(d => d.code === 'PAN_CARD').file} target="_blank" rel="noopener noreferrer" className="small">View Current PAN</a>
                                            </div>
                                        )}
                                        <Form.Control
                                            type="file"
                                            name="panFile"
                                            accept="image/*,.pdf"
                                            onChange={(e) => setFieldValue('panFile', e.currentTarget.files[0])}
                                        />
                                        {errors.panFile && touched.panFile && (
                                            <Form.Text className="text-danger">{errors.panFile}</Form.Text>
                                        )}
                                    </Form.Group>

                                    {/* 3. Cancel Cheque Upload */}
                                    <Form.Group controlId="cancelChequeFile">
                                        <Form.Label>
                                            Cancel Cheque {(!this.state.isSettlementEditMode || !this.state.settlementVendor?.documents?.find(d => d.code === 'CANCEL_CHEQUE')) && <span className="text-danger">*</span>}
                                        </Form.Label>
                                        {this.state.isSettlementEditMode && this.state.settlementVendor?.documents?.find(d => d.code === 'CANCEL_CHEQUE') && (
                                            <div className="mb-2">
                                                <small className="text-success mr-2">Existing: </small>
                                                <a href={this.state.settlementVendor.documents.find(d => d.code === 'CANCEL_CHEQUE').file} target="_blank" rel="noopener noreferrer" className="small">View Current Cheque</a>
                                            </div>
                                        )}
                                        <Form.Control
                                            type="file"
                                            name="cancelChequeFile"
                                            accept="image/*,.pdf"
                                            onChange={(e) => setFieldValue('cancelChequeFile', e.currentTarget.files[0])}
                                        />
                                        {errors.cancelChequeFile && touched.cancelChequeFile && (
                                            <Form.Text className="text-danger">{errors.cancelChequeFile}</Form.Text>
                                        )}
                                    </Form.Group>

                                    <hr />

                                    {/* Settlement Confirmation Label */}
                                    <div style={{
                                        background: this.state.isSettlementEditMode ? '#eff6ff' : '#fff8e1',
                                        padding: '12px 16px',
                                        borderRadius: '8px',
                                        border: this.state.isSettlementEditMode ? '1px solid #bfdbfe' : '1px solid #ffe082',
                                        marginBottom: '1rem'
                                    }}>
                                        <p className="mb-0 font-weight-bold">
                                            <i className={this.state.isSettlementEditMode ? 'flaticon-edit mr-2' : 'flaticon-warning-sign mr-2'}
                                                style={{ color: this.state.isSettlementEditMode ? '#2563eb' : '#f9a825' }}></i>
                                            {this.state.isSettlementEditMode
                                                ? 'Update KYC Documents'
                                                : 'Mark this Account Settlement'}
                                        </p>
                                        <p className="mb-0 small text-muted mt-1">
                                            {this.state.isSettlementEditMode
                                                ? 'Upload new documents to replace existing KYC documents for this vendor.'
                                                : 'This will upload the KYC documents and create a settlement account on Cashfree for payouts.'}
                                        </p>
                                    </div>

                                    {/* Action Buttons */}
                                    <Row>
                                        <Col xs={12} className="text-right">
                                            <Button
                                                variant="secondary"
                                                className="mr-2"
                                                onClick={() => this.toggleSettlementModal(null)}
                                                disabled={this.state.isSettlementSubmitting}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant={this.state.isSettlementEditMode ? 'primary' : 'success'}
                                                disabled={this.state.isSettlementSubmitting}
                                            >
                                                {this.state.isSettlementSubmitting
                                                    ? 'Processing...'
                                                    : this.state.isSettlementEditMode ? 'Update Documents' : 'Yes'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    </Modal.Body>
                </Modal>

            </>
        );
    }
}

const mapStateToProps = state => ({
    serviceRequestCategories: state.auth && state.auth.staticData && state.auth.staticData.serviceRequests && state.auth.staticData.serviceRequests.categories,
    vendorCategories: state.auth && state.auth.staticData && state.auth.staticData.vendors && state.auth.staticData.vendors.categories,
    userDetails: state.auth && state.auth.user,
});

export default connect(mapStateToProps, null)(Vendors);
